import { render, staticRenderFns } from "./dataCollectionDetail.vue?vue&type=template&id=1bf66ba6&scoped=true"
import script from "./dataCollectionDetail.vue?vue&type=script&lang=js"
export * from "./dataCollectionDetail.vue?vue&type=script&lang=js"
import style0 from "./dataCollectionDetail.vue?vue&type=style&index=0&id=1bf66ba6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf66ba6",
  null
  
)

export default component.exports